import { resolve } from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import { footerCss } from 'components/Auth/styles';
import Separator from './Separator';
import AuthTypes from './AuthTypes';
import AuthButton from './Button';
import Header from './Header';
import StageWrapper from './StageWrapper';

interface Props {
  onClickGoogle(): void;
  onClickFacebook(): void;
  onClickEmail(): void;
  onClickCreateAccount(): void;
}

const buttonCss = resolve`
  .button {
    margin: .4em 0;
  }
`;

export default function Login({
  onClickEmail,
  onClickFacebook,
  onClickGoogle,
  onClickCreateAccount,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <StageWrapper>
      <Header>
        <h1 data-testid="headline">{t('auth.logIn.headline')}</h1>
        <p className="description">{t('auth.logIn.description')}</p>
        <Separator />
      </Header>
      <AuthButton type={AuthTypes.Google} onClick={onClickGoogle} className={buttonCss.className}>
        {t('auth.logIn.google')}
      </AuthButton>
      <AuthButton
        type={AuthTypes.Facebook}
        onClick={onClickFacebook}
        className={buttonCss.className}
      >
        {t('auth.logIn.facebook')}
      </AuthButton>
      <AuthButton type={AuthTypes.Email} onClick={onClickEmail} className={buttonCss.className}>
        {t('auth.logIn.email')}
      </AuthButton>
      {buttonCss.styles}
      {footerCss.styles}
      <button className={`footer ${footerCss.className}`} onClick={onClickCreateAccount}>
        {t('auth.logIn.createAccount')}
      </button>
      <style jsx>{`
        .description {
          color: ${colors.G3};
        }
      `}</style>
    </StageWrapper>
  );
}
